export const getDiscountedTotal = ({ total, projectDiscount }) => {
  if (!projectDiscount || projectDiscount.type === 'none') return { finalTotal: total, discount: 0 }
  let finalTotal = total
  let discount = 0

  if (projectDiscount.type === 'percentage') {
    discount = (projectDiscount.value / 100) * total
  }

  if (projectDiscount.type === 'fixed') {
    discount = projectDiscount.value
  }
  finalTotal -= discount

  return { discount, finalTotal }
}
